/*
 * Sexy Hair Care Landing — variant-dropdown price-swap + AJAX cart add (WEB-6238).
 *
 * Companion to snippets/sexyhair-care-buy-dropdown.liquid. The snippet
 * renders a <details> dropdown with one <button type="submit"> per variant.
 * This script:
 *   1. Mirrors the hovered variant's price into the card's displayed price
 *      so customers see the exact price before they commit.
 *   2. Intercepts the form submit and posts to /cart/add (Accept:
 *      application/javascript so Shopify returns JSON) with the sections
 *      the existing <cart-notification> needs, then asks it to render —
 *      so adding to cart pops the same notification banner used across
 *      the rest of the storefront instead of navigating to /cart.
 *
 * Idempotent — re-running (e.g. via theme-editor section reload) won't
 * double-bind because each <details> is marked with `data-bound`.
 */

(function () {
  'use strict';

  function findPriceElement(detailsEl) {
    var card = detailsEl.closest('.sexyhair-care-landing__product-card');
    if (!card) return null;
    var selector = detailsEl.getAttribute('data-price-target') || '.sexyhair-care-landing__product-price';
    return card.querySelector(selector);
  }

  function getCartNotification() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function showBannerInstant(cart) {
    // Open the banner before the fetch resolves so the user gets
    // immediate feedback. sexyhair-cart-notification.liquid patches
    // CartNotification.prototype.open to also schedule the auto-dismiss
    // timer, so this single call handles both show + dismiss timing.
    if (cart && typeof cart.open === 'function') {
      try { cart.open(); return; } catch (_e) { /* fall through to the manual banner */ }
    }
    // Fallback: replicate the snippet's showBanner if cart.open isn't
    // available yet (e.g. cart-notification custom element not defined).
    var notification = document.getElementById('cart-notification');
    if (!notification) return;
    notification.style.display = '';
    notification.classList.add('animate', 'active');
  }

  function hideBanner(cart) {
    // Used on cart/add failure so we don't leave a green-light banner
    // showing for an add that never happened. Mirrors the existing
    // hideBanner() in sexyhair-cart-notification.liquid: drop .active
    // (triggers the slide-up animation), then remove .animate after the
    // animation ends so the banner is fully torn down — leaving .animate
    // on would keep it in a stale visual state.
    var notification = (cart && cart.notification) || document.getElementById('cart-notification');
    if (!notification || !notification.classList.contains('active')) return;
    notification.classList.remove('active');
    notification.addEventListener('animationend', function handler() {
      notification.classList.remove('animate');
      notification.removeEventListener('animationend', handler);
    });
  }

  function ajaxAdd(form, submitter) {
    var cart = getCartNotification();
    var formData = new FormData(form);
    // <button name="id" value="..."> on a real form submit injects its own
    // name/value pair, but synthetic .submit() and our preventDefault
    // path don't — so set it explicitly from the clicked option.
    if (submitter && submitter.name === 'id' && submitter.value) {
      formData.set('id', submitter.value);
    }
    if (cart && typeof cart.getSectionsToRender === 'function') {
      var sectionIds = cart.getSectionsToRender().map(function (s) { return s.id; });
      formData.append('sections', sectionIds.join(','));
      formData.append('sections_url', window.location.pathname + window.location.search);
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(submitter || document.activeElement);
      }
    }

    // Show the banner BEFORE the network request — gives the user
    // instant feedback. renderContents() later refreshes the cart-icon
    // bubble and view-cart link with the real server state.
    showBannerInstant(cart);

    return fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          // Shopify returned an error payload (variant out of stock,
          // quantity rule, etc.). Hide the optimistic banner so the
          // user doesn't see a false-positive "added" state.
          console.error('[care-buy-dropdown] cart/add error', response);
          hideBanner(cart);
          return;
        }
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        }
      })
      .catch(function (err) {
        console.error('[care-buy-dropdown] cart/add failed', err);
        hideBanner(cart);
      });
  }

  function bind(detailsEl) {
    if (detailsEl.hasAttribute('data-bound')) return;
    detailsEl.setAttribute('data-bound', '');

    var priceEl = findPriceElement(detailsEl);
    var form = detailsEl.querySelector('form');
    var options = detailsEl.querySelectorAll('[data-variant-price]');
    if (!form || !options.length) return;

    var originalPriceHTML = priceEl ? priceEl.innerHTML : null;

    function preview(text) {
      if (priceEl) priceEl.textContent = text;
    }

    function restore() {
      if (priceEl && originalPriceHTML !== null) priceEl.innerHTML = originalPriceHTML;
    }

    options.forEach(function (opt) {
      if (opt.disabled) return;
      var price = opt.getAttribute('data-variant-price');
      opt.addEventListener('pointerenter', function () { preview(price); });
      opt.addEventListener('focus', function () { preview(price); });
    });

    detailsEl.addEventListener('mouseleave', restore);
    detailsEl.addEventListener('focusout', function (e) {
      if (!detailsEl.contains(e.relatedTarget)) restore();
    });
    detailsEl.addEventListener('toggle', function () {
      if (detailsEl.open) {
        // Close any other Care dropdown that's currently open so we
        // only ever show one at a time.
        document.querySelectorAll('[data-care-variant-dropdown][open]').forEach(function (other) {
          if (other !== detailsEl) other.open = false;
        });
      } else {
        restore();
      }
    });

    // Track which option triggered the submit so AJAX gets the right
    // variant ID (`event.submitter` isn't supported by older Safari).
    var lastClicked = null;
    options.forEach(function (opt) {
      opt.addEventListener('click', function () { lastClicked = opt; });
    });

    var busy = false;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      busy = true;

      var submitter = e.submitter || lastClicked;
      if (submitter) submitter.setAttribute('aria-disabled', 'true');
      detailsEl.open = false;
      restore();

      ajaxAdd(form, submitter).finally(function () {
        busy = false;
        if (submitter) submitter.removeAttribute('aria-disabled');
      });
    });
  }

  function init() {
    var dropdowns = document.querySelectorAll('[data-care-variant-dropdown]');
    dropdowns.forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-bind when the theme editor re-renders the section.
  document.addEventListener('shopify:section:load', init);
})();
